// extracted by mini-css-extract-plugin
module.exports = {"openContainer":"GripAnalysisSideBar_openContainer_3kAyn","closeContainer":"GripAnalysisSideBar_closeContainer_3QYBh","spinAround":"GripAnalysisSideBar_spinAround_25Xkv"};